module.exports = __webpack_public_path__ + "img/03.90191a98.png";